<script lang="ts">
  import SolfegeButton from './SolfegeButton.svelte';

  export let mode: {
    name: string;
    notes: number;
    solfegeButtonsDo: string[];
    solfegeButtonsLa: string[];
    scaleDegreeButtons: string[];
  };
  export let buttonNames: string[];
  export let disabled: boolean;
  export let checkAnswer: (scaleDegree: number, noteIsMinor?: boolean) => void;
</script>

<div aria-disabled={disabled}>
  <h3 class="sr-only">Solfege/Scale-Degree Buttons</h3>
  <SolfegeButton id="D" {disabled} label={buttonNames[0]} onPress={() => checkAnswer(1)} />
  <SolfegeButton id="R" {disabled} label={buttonNames[1]} onPress={() => checkAnswer(2)} />
  {#if mode.name === 'Major'}
    <SolfegeButton id="M" {disabled} label={buttonNames[2]} onPress={() => checkAnswer(3)} />
  {:else}
    <SolfegeButton id="M" {disabled} label={buttonNames[2]} onPress={() => checkAnswer(3, true)} />
  {/if}
  <SolfegeButton id="F" {disabled} label={buttonNames[3]} onPress={() => checkAnswer(4)} />
  <SolfegeButton id="S" {disabled} label={buttonNames[4]} onPress={() => checkAnswer(5)} />
  {#if mode.name === 'Major'}
    <SolfegeButton id="L" {disabled} label={buttonNames[5]} onPress={() => checkAnswer(6)} />
    <SolfegeButton id="T" {disabled} label={buttonNames[6]} onPress={() => checkAnswer(7)} />
  {:else if mode.name === 'Natural Minor'}
    <SolfegeButton id="L" {disabled} label={buttonNames[5]} onPress={() => checkAnswer(6, true)} />
    <SolfegeButton id="T" {disabled} label={buttonNames[6]} onPress={() => checkAnswer(7, true)} />
  {:else if mode.name === 'Harmonic Minor'}
    <SolfegeButton id="L" {disabled} label={buttonNames[5]} onPress={() => checkAnswer(6, true)} />
    <SolfegeButton id="T" {disabled} label={buttonNames[6]} onPress={() => checkAnswer(7)} />
  {:else if mode.name === 'Natural and Harmonic Minor'}
    <SolfegeButton id="L" {disabled} label={buttonNames[5]} onPress={() => checkAnswer(6, true)} />
    <SolfegeButton
      id="TE"
      half="bottom"
      {disabled}
      label={buttonNames[6]}
      onPress={() => checkAnswer(7, true)}
    />
    <SolfegeButton
      id="TI"
      half="top"
      {disabled}
      label={buttonNames[7]}
      onPress={() => checkAnswer(7)}
    />
  {:else if mode.name === 'Natural and Melodic Minor'}
    <SolfegeButton
      id="LE"
      half="bottom"
      {disabled}
      label={buttonNames[5]}
      onPress={() => checkAnswer(6, true)}
    />
    <SolfegeButton
      id="LA"
      half="top"
      {disabled}
      label={buttonNames[6]}
      onPress={() => checkAnswer(6)}
    />
    <SolfegeButton
      id="TE"
      half="bottom"
      {disabled}
      label={buttonNames[7]}
      onPress={() => checkAnswer(7, true)}
    />
    <SolfegeButton
      id="TI"
      half="top"
      {disabled}
      label={buttonNames[8]}
      onPress={() => checkAnswer(7)}
    />
  {/if}
</div>
